import React, { useEffect } from "react";
import Breadcrumb2 from "../../../Components/Breadcrumb2/Breadcrumb2";
import CustomerCare from "../../../Components/CustomerCare/CustomerCare";
import OurStores from "../../../Components/OurStories/OurStores";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const IzbZaffico2026Marathon = () => {
    const BackgroundBrundcrumb = "https://izbassetsmain.blob.core.windows.net/izbwebassets/Image_1.png";
    const ArrowLeft = "https://izbassetsmain.blob.core.windows.net/izbwebassets/LeftArrow.png";
    const ArrowRight = "https://izbassetsmain.blob.core.windows.net/izbwebassets/RightArrow.png";

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    function SamplePrevArrow(props) {
        const { className, style, onClick } = props;
        return (
            <img
                src={ArrowLeft}
                className={className}
                style={{
                    ...style,
                    display: "block",
                    width: "50px",
                    height: "50px",
                    left: "-58px",
                    zIndex: "99"
                }}
                onClick={onClick}
            />
        );
    }

    function SampleNextArrow(props) {
        const { className, style, onClick } = props;
        return (
            <img
                src={ArrowRight}
                className={className}
                onClick={onClick}
            />
        );
    }

    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        lazyLoad: "ondemand",
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true,
                },
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    };

    const galleryImages = [
        "image2.jpeg",
        "image1.jpeg",
        "image3.jpeg",
        "image4.jpeg",
        "image5.jpeg",
        "image6.jpeg",
        "image7.jpeg",
        "image8.jpeg",
        "image9.jpeg",
    ];

    return (
        <>
            <Breadcrumb2
                Heading="Latest News"
                img={BackgroundBrundcrumb}
                show={true}
            />

            <section>
                <div className="container pt-5">
                    <h1 className="pb-5 text-left">Indo Zambia Bank Unveiled as Lead Sponsor of the 2026 ZAFFICO Marathon</h1>

                    <p className="pb-3">Indo Zambia Bank has been unveiled as one of the lead corporate sponsors of the 2026 ZAFFICO Marathon. The announcement was made yesterday at ZAFFICO Headquarters in Lusaka, marking the Bank's second consecutive year partnering with ZAFFICO.</p>

                    <p className="pb-3">This year's theme, "Run for Maternal Health. Run for Nature," brings together two causes that directly impact communities and future generations. As our General Manager, Mr. Godwin C. Ngoma, noted during the official kit unveiling:</p>

                    <p className="pb-3">"The ZAFFICO Marathon is more than a sporting event. It is a platform that unites people around a shared purpose and inspires collective action for meaningful causes... When we invest in maternal health, we invest in stronger families, healthier communities and a brighter future for generations to come."</p>

                    <p className="pb-3">By supporting this initiative, we are helping to promote access to maternal healthcare while contributing to the protection of our natural environment. Trees sustain ecosystems, protect biodiversity and combat climate change, making environmental conservation a cause that affects us all and aligns with ZAFFICO's core mandate in forestry and environmental protection.</p>

                    <p className="pb-3">At Indo Zambia Bank, our brand promise, "Supporting You, Developing Zambia," reflects our belief that banking goes beyond financial services. It means standing with you to improve the wellbeing of our communities, support healthier families and safeguard our nation's natural resources for generations to come.</p>

                    <p className="pb-3">Whether you are chasing a personal best or taking a walk for a cause that matters, there's a race category for everyone. Choose your distance, register today, and join us in running for causes that matter. Let us come together in large numbers to make the 2026 ZAFFICO Marathon a resounding success. Every step counts, and together, we can make a difference!</p>

                    <p className="pb-3"><b><em>#IndoZambiaBank #ZAFFICOMarathon2026 #RunForMaternalHealth #RunForNature #SupportingYouDevelopingZambia</em></b></p>

                    <h2 className="pt-5 pb-4 text-left">Gallery</h2>
                    <Slider {...settings}>
                        {galleryImages.map((name) => (
                            <div className="px-2" key={name}>
                                <img
                                    src={`https://izbassetsmain.blob.core.windows.net/izbwebassets/${name}`}
                                    style={{ width: "100%", height: "500px", objectFit: "cover" }}
                                    alt="Gallery"
                                />
                            </div>
                        ))}
                    </Slider>
                </div>
            </section>

            <CustomerCare />
            <OurStores />
        </>
    );
};

export default IzbZaffico2026Marathon;
